<script lang="ts">
  import Icon from '$lib/components/Icon.svelte'

  const { onClose }: { onClose: () => void } = $props()
</script>

<button
  class="absolute right-3 top-3 text-surface-600 hover:text-primary-600 dark:text-surface-400 dark:hover:text-primary-300"
  type="button"
  onclick={onClose}
>
  <Icon icon="iconoir:xmark-circle" />
</button>
